import script from "./LeagueSections.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueSections.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueSections.vue?vue&type=style&index=0&id=264c947d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264c947d"]])

export default __exports__